import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Settings, Link2 } from 'lucide-react';

const ClinicLayout = ({ children }) => {
  const location = useLocation();

  const navItems = [
    {
      path: '/clinic/dashboard',
      icon: Home,
      label: 'Dashboard'
    },
    {
      path: '/clinic/link-in-bio',
      icon: Link2,
      label: 'Link in Bio'
    }
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="min-h-[calc(100vh-5rem)] flex">
      {/* Sidebar */}
      <aside className="w-64 bg-white dark:bg-obsidian border-r border-light-border dark:border-border flex-shrink-0">
        <nav className="p-4 space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-smooth ${
                  active
                    ? 'bg-gradient-silver text-obsidian font-medium'
                    : 'text-light-text dark:text-silver hover:bg-slate-100 dark:hover:bg-white/5'
                }`}
              >
                <Icon className="w-5 h-5" />
                <span className="font-mono text-sm uppercase tracking-wider">
                  {item.label}
                </span>
              </Link>
            );
          })}
        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        {children}
      </main>
    </div>
  );
};

export default ClinicLayout;
